// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.music-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  margin: 4px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.music-button:hover {

}

.now-playing {
  display: flex;
  align-items: center;
  padding: 8px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  margin-top: 8px;
}

.track-info {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 0; /* Removed padding-right since control is now on the right */
}

.track-title {
  font-size: 14px;
  color: #454545;
  font-weight: normal; /* Ensure consistent font weight */
}

/* Remove hover effects for play/pause buttons */




/* Music Player Button - similar to dice roller buttons */
.music-player-button {
  position: fixed;
  right: 90px; /* Moved slightly to the left from right edge */
  bottom: 20px; /* Positioned at bottom */
  width: 60px;
  height: 60px;
  background-color: #df2d11; /* Red color matching dice roller buttons */
  border: none;
  border-radius: 50px;
  cursor: pointer;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  color: white;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease;
  box-sizing: border-box;
  padding: 0;
}

.music-player-button:hover {
  transform: scale(1.05);
}

.music-player-button svg {
  width: 24px;
  height: 24px;
  position: relative;
  top: 0; /* Adjusted from -3px to fix alignment */
}

.music-player-button span {
  font-size: 12px;
  font-family: "Gabarito", serif;
  line-height: 1;
  margin-top: 2px; /* Add slight spacing between icon and text */
}

/* Update the playing state - remove glow effect */
.music-player-button.playing {
  background-color: #df2d11; /* Lighter red to indicate playing */
  /* Removed the box-shadow glow effect */
}

/* Control button for play/pause */
.music-player-control {
  position: fixed;
  right: 20px;
  bottom: 510px; /* Below the music button */
  width: 60px;
  height: 60px;
  background-color: #4caf50; /* Green for play control */
  border: none;
  border-radius: 50px;
  cursor: pointer;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease;
}

.music-player-control:hover {
  transform: scale(1.05);
}

.music-player-control svg {
  width: 24px;
  height: 24px;
}

/* Modal Styles */
.music-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.music-modal-content {
  background-color: #faf8f5;
  color: black;
  padding: 32px 24px;
  border-radius: 16px;
  width: 450px;
  max-height: 90vh;
  overflow-y: auto;
}

.music-modal-content h2 {
  margin-top: 0;
  color: black;
  font-size: 24px;
  text-align: center;
  font-family: 'Crimson', serif;
}

.volume-control {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  margin-top: 10px;
}

.volume-slider {
  flex: 1 1;
  height: 5px;
  appearance: none;
  background: linear-gradient(to right, #df2d11, #E5E7EB);
  border-radius: 5px;
  outline: none;
}

.volume-slider::-webkit-slider-thumb {
  appearance: none;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #df2d11;
  cursor: pointer;
}

/* Style the play button in the volume control */
.volume-play-button {
  min-width: auto !important;
  height: auto !important;
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 8px 0 0 !important; /* Consistent spacing with other icons */
  transform: none !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.volume-play-button svg {
  width: 18px;
  height: 18px;
  color: inherit; /* Use the same color as other icons */
}

/* Prevent hover effects on volume play button */
.volume-play-button:hover,
.volume-play-button:focus,
.volume-play-button:active {
  background: transparent !important;
  border: none !important;
  transform: none !important;
  box-shadow: none !important;
  color: inherit !important;
  opacity: 1 !important;
}

/* Updated track list styles */
.tracks-container {
  max-height: 250px;
  overflow-y: auto;
  margin-bottom: 20px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.track-list {
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  padding: 0;
}

.track-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: background-color 0.2s;
  height: 40px; /* Fixed height for all items */
  box-sizing: border-box;
}

.track-item:last-child {
  border-bottom: none;
}

.track-item.active {
  background-color: rgba(223, 45, 17, 0.1);
}

/* Adjust the track control container */
.track-control {
  width: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
}

/* Responsive styling for mobile */
@media (max-width: 576px) {
  .music-player-button {
    right: 16px;
    bottom: 580px;
  }
  
  .music-player-control {
    right: 16px;
    bottom: 510px;
  }
  
  .music-modal-content {
    width: 90%;
    max-width: 400px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MusicPlayer/MusicPlayer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;AAEA;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB,EAAE,4DAA4D;AAChF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB,EAAE,kCAAkC;AACzD;;AAEA,gDAAgD;;;;;AAKhD,yDAAyD;AACzD;EACE,eAAe;EACf,WAAW,EAAE,+CAA+C;EAC5D,YAAY,EAAE,yBAAyB;EACvC,WAAW;EACX,YAAY;EACZ,yBAAyB,EAAE,2CAA2C;EACtE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,+CAA+C;EAC/C,+BAA+B;EAC/B,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM,EAAE,wCAAwC;AAClD;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,cAAc;EACd,eAAe,EAAE,6CAA6C;AAChE;;AAEA,kDAAkD;AAClD;EACE,yBAAyB,EAAE,oCAAoC;EAC/D,uCAAuC;AACzC;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,WAAW;EACX,aAAa,EAAE,2BAA2B;EAC1C,WAAW;EACX,YAAY;EACZ,yBAAyB,EAAE,2BAA2B;EACtD,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,+CAA+C;EAC/C,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,WAAW;EAEX,gBAAgB;EAChB,uDAAuD;EACvD,kBAAkB;EAClB,aAAa;AACf;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;EACrB,4BAA4B,EAAE,wCAAwC;EACtE,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc,EAAE,sCAAsC;AACxD;;AAEA,gDAAgD;AAChD;;;EAGE,kCAAkC;EAClC,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,4CAA4C;EAC5C,eAAe;EACf,iCAAiC;EACjC,YAAY,EAAE,+BAA+B;EAC7C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF","sourcesContent":[".music-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  margin: 4px;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.music-button:hover {\n\n}\n\n.now-playing {\n  display: flex;\n  align-items: center;\n  padding: 8px;\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n  margin-top: 8px;\n}\n\n.track-info {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-right: 0; /* Removed padding-right since control is now on the right */\n}\n\n.track-title {\n  font-size: 14px;\n  color: #454545;\n  font-weight: normal; /* Ensure consistent font weight */\n}\n\n/* Remove hover effects for play/pause buttons */\n\n\n\n\n/* Music Player Button - similar to dice roller buttons */\n.music-player-button {\n  position: fixed;\n  right: 90px; /* Moved slightly to the left from right edge */\n  bottom: 20px; /* Positioned at bottom */\n  width: 60px;\n  height: 60px;\n  background-color: #df2d11; /* Red color matching dice roller buttons */\n  border: none;\n  border-radius: 50px;\n  cursor: pointer;\n  z-index: 1001;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  color: white;\n  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.3);\n  transition: transform 0.2s ease;\n  box-sizing: border-box;\n  padding: 0;\n}\n\n.music-player-button:hover {\n  transform: scale(1.05);\n}\n\n.music-player-button svg {\n  width: 24px;\n  height: 24px;\n  position: relative;\n  top: 0; /* Adjusted from -3px to fix alignment */\n}\n\n.music-player-button span {\n  font-size: 12px;\n  font-family: \"Gabarito\", serif;\n  line-height: 1;\n  margin-top: 2px; /* Add slight spacing between icon and text */\n}\n\n/* Update the playing state - remove glow effect */\n.music-player-button.playing {\n  background-color: #df2d11; /* Lighter red to indicate playing */\n  /* Removed the box-shadow glow effect */\n}\n\n/* Control button for play/pause */\n.music-player-control {\n  position: fixed;\n  right: 20px;\n  bottom: 510px; /* Below the music button */\n  width: 60px;\n  height: 60px;\n  background-color: #4caf50; /* Green for play control */\n  border: none;\n  border-radius: 50px;\n  cursor: pointer;\n  z-index: 1001;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.3);\n  transition: transform 0.2s ease;\n}\n\n.music-player-control:hover {\n  transform: scale(1.05);\n}\n\n.music-player-control svg {\n  width: 24px;\n  height: 24px;\n}\n\n/* Modal Styles */\n.music-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.music-modal-content {\n  background-color: #faf8f5;\n  color: black;\n  padding: 32px 24px;\n  border-radius: 16px;\n  width: 450px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.music-modal-content h2 {\n  margin-top: 0;\n  color: black;\n  font-size: 24px;\n  text-align: center;\n  font-family: 'Crimson', serif;\n}\n\n.volume-control {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 20px;\n  margin-top: 10px;\n}\n\n.volume-slider {\n  flex: 1;\n  height: 5px;\n  -webkit-appearance: none;\n  appearance: none;\n  background: linear-gradient(to right, #df2d11, #E5E7EB);\n  border-radius: 5px;\n  outline: none;\n}\n\n.volume-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  background: #df2d11;\n  cursor: pointer;\n}\n\n/* Style the play button in the volume control */\n.volume-play-button {\n  min-width: auto !important;\n  height: auto !important;\n  background: transparent !important;\n  border: none !important;\n  padding: 0 !important;\n  margin: 0 8px 0 0 !important; /* Consistent spacing with other icons */\n  transform: none !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.volume-play-button svg {\n  width: 18px;\n  height: 18px;\n  color: inherit; /* Use the same color as other icons */\n}\n\n/* Prevent hover effects on volume play button */\n.volume-play-button:hover,\n.volume-play-button:focus,\n.volume-play-button:active {\n  background: transparent !important;\n  border: none !important;\n  transform: none !important;\n  box-shadow: none !important;\n  color: inherit !important;\n  opacity: 1 !important;\n}\n\n/* Updated track list styles */\n.tracks-container {\n  max-height: 250px;\n  overflow-y: auto;\n  margin-bottom: 20px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n}\n\n.track-list {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0;\n  padding: 0;\n}\n\n.track-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n  transition: background-color 0.2s;\n  height: 40px; /* Fixed height for all items */\n  box-sizing: border-box;\n}\n\n.track-item:last-child {\n  border-bottom: none;\n}\n\n.track-item.active {\n  background-color: rgba(223, 45, 17, 0.1);\n}\n\n/* Adjust the track control container */\n.track-control {\n  width: 26px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 8px;\n}\n\n/* Responsive styling for mobile */\n@media (max-width: 576px) {\n  .music-player-button {\n    right: 16px;\n    bottom: 580px;\n  }\n  \n  .music-player-control {\n    right: 16px;\n    bottom: 510px;\n  }\n  \n  .music-modal-content {\n    width: 90%;\n    max-width: 400px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
